<template>
  <message-dialog
    v-model="dialogOpen"
    title="Select Option"
    column
    @hide="hide"
  >
    <q-item-label>
      Select an option for creating your inventory item:
    </q-item-label>

    <template #actions>
      <q-item-wrapper
        icon="mdi-book-search"
        icon-right="mdi-chevron-right"
        clickable
        color="black"
        top
        @click="select('prefill')"
      >
        <q-item-label class="text-bold">
          Select Inventory Prefills
        </q-item-label>
        <!-- Necessary to avoid margin top within message dialog for QItemLabels -->
        <q-space />
        <q-item-label caption class="q-pt-xs">
          Quickly add prefilled inventory and chemicals to your business template collection
        </q-item-label>
      </q-item-wrapper>

      <q-item-wrapper
        label="Create from scratch"
        icon="mdi-package-variant-plus"
        icon-right="mdi-chevron-right"
        clickable
        label-class="text-bold"
        color="blue-8"
        @click="select('create')"
      />

      <q-separator inset spaced />

      <q-item-wrapper tag="label" dense>
        <q-checkbox
          v-model="dismissDialogCheckbox"
          label="Don't show this dialog again"
        />
      </q-item-wrapper>
    </template>
  </message-dialog>
</template>

<script>
// Refer to https://quasar.dev/quasar-plugins/dialog#Invoking-custom-component
import awardNewbie from 'src/helpers/awardNewbie'

export default {
  emits: [
    'ok', 'hide'
  ],
  data () {
    return {
      dialogOpen: false,
      dismissDialogCheckbox: false
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.dialogOpen = true
      this.dismissDialogCheckbox = false
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    async hide () {
      if (this.dismissDialogCheckbox) {
        await awardNewbie(this.newbies.setupDismissPrefillInventory, 'user')
      }

      this.$emit('hide')
    },
    select (val) {
      this.$emit('ok', val)
      this.hide()
    }
  }
}
</script>
